<template>
  <div class="mobile-redirect">
    <h2>Opening Segofy App...</h2>
    <p>If the app doesn't open, please open it manually.</p>
  </div>
</template>

<script>
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'

export default {
  name: 'MobileRedirect',
  setup() {
    const router = useRouter()

    onMounted(() => {
      const route = router.currentRoute.value
      
      // Extract the path after /mobile/
      const currentPath = route.path
      const mobilePath = currentPath.replace('/mobile', '') || '/'
      
      // Build query string from query params
      const queryString = Object.keys(route.query).length > 0
        ? '?' + new URLSearchParams(route.query).toString()
        : ''
      
      // Include hash if present
      const hash = route.hash || ''
      
      // Construct the app URL: segofy://mobile/path?query#hash
      const appUrl = `segofy://mobile${mobilePath}${queryString}${hash}`
      
      // Try to open the app
      window.location.href = appUrl

      // Fallback after 2 seconds
      setTimeout(() => {
        router.push('/')
      }, 2000)
    })

    return {}
  }
}
</script>

<style scoped>
.mobile-redirect {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 2rem;
  text-align: center;
}

.mobile-redirect h2 {
  margin-bottom: 1rem;
  font-size: 1.5rem;
}

.mobile-redirect p {
  color: #666;
  font-size: 1rem;
}
</style>

